"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _Hub = _interopRequireWildcard(require("./Hub"));

var _AppActions = require("../actions/AppActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  data: (0, _Hub.default)(),
  staged: (0, _Hub.EditableHub)(),
  suggestedAccountName: {},
  portalScopes: []
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchHubActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    data: (0, _Hub.default)(action.payload.data),
    staged: (0, _Hub.EditableHub)(action.payload.data)
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveHubActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    data: (0, _Hub.default)(action.payload.data),
    staged: (0, _Hub.EditableHub)(action.payload.data)
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.HubActionTypes.STAGE_HUB_CHANGE, function (state, action) {
  return state.setIn(['staged', action.payload.key], action.payload.value);
}), (0, _defineProperty2.default)(_handleActions, _AppActions.AppActionTypes.RESET_STAGED_CHANGES, function (state) {
  return state.set('staged', (0, _Hub.EditableHub)(state.get('data')));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchSuggestedAccountNameActionTypes.SUCCESS, function (state, action) {
  return state.set('suggestedAccountName', (0, _immutable.fromJS)(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPortalScopesActionTypes.SUCCESS, function (state, action) {
  return state.set('portalScopes', action.payload.data.scopes);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;